
import { withAgentReferral } from "~/utils/agent-referral";

const cxErrorMessageAppend = "Please email our CX team at cxc@malayan.com or call our hotline at (02) 8628-8628.";
const techSupportErrorMessageAppend = "A technical issue has been detected, please coordinate with Malayan technical team at ecommerce@malayan.com or call our hotline at (02) 8628-8628.";
const baseAgentCode = process.env.baseAgentCode;
const basePromoCode = process.env.basePromoCode;

export default {
    spacingDebug: true,
    props: {
        product_plans_payload: {
            type: [Object, Array],
            default: () => ({}),
        },
        product_plan_tabs_payload: {
            type: Object,
            default: () => ({
                Items: {
                    categories: [
                        {
                            slug: "general",
                            title: "General",
                            active: true,
                        },
                        {
                            slug: "surgeon",
                            title: "Surgeon",
                            active: false,
                        },
                        {
                            slug: "anesthesiologist",
                            title: "Anesthesiologist",
                            active: false,
                        },
                    ],
                },
            }),
        },
        product_plan_selected_payload: {
            type: [Object, Array],
            default: () => ({}),
        },
    },
    data: ({ product_plans_payload, product_plan_tabs_payload, product_plan_selected_payload }) => ({
        isReady: false,
        productPlans: product_plans_payload,
        productPlanTabs: product_plan_tabs_payload,
        productPlanSelected: product_plan_selected_payload,
        quotationReference: {},
        modals: [
            {
                id: "show-plan-details",
                name: "",
                title: "",
                subtitle: "",
                description: "",
                show: false,
                logo: true,
                button: false,
                shortDescription: false,
            },
        ],
    }),
    methods: {
        async initialize() {
            const categorySlug = this.$route?.params?.category;
            const productSlug = this.$route?.params?.product;
            const formUrl = `web/product-application/quotation/fetch-all/${categorySlug}/${productSlug}`;
            const formRequest = {
                Productcategoryslug: categorySlug,
                Productslug: productSlug,
                Categoriesslug: this.getProductPlanTabSlug("categories"),
                Isspecialcodesavailable: false,
                Agentcode: baseAgentCode !== null ? baseAgentCode : null,
                Promocode: basePromoCode !== null ? basePromoCode : null,
            };
            const formRequestEncrypted = {
                dt: this.encryptionData(withAgentReferral(formRequest, this.getSecureLSData("__redirection_code_details__"))),
            };
            try {
                this.toggleLoaderStatus({ type: "translucent", status: true });
                const response = await this.$axios.$post(formUrl, formRequestEncrypted);
                if (response?.data?.attributes) {
                    const decrypted = this.decryptionData(response?.data?.attributes.encrypted);
                    if (decrypted.validated_request && decrypted.product_plans && decrypted.product_plans.length > 0 && Array.isArray(decrypted.product_plans)) {
                        this.saveSecureLSData("__form_data__", decrypted.validated_request);
                        const productPlans = decrypted.product_plans;
                        if (productPlans) {
                            this.productPlans = {
                                Productcategoryslug: categorySlug,
                                Productslug: productSlug,
                                Items: { ...productPlans },
                            };
                            this.saveSecureLSData("__product_plans__", this.productPlans);
                            this.productPlanTabs = {
                                ...this.productPlanTabs,
                                Productcategoryslug: categorySlug,
                                Productslug: productSlug,
                            };
                            this.saveSecureLSData("__product_plan_tabs__", this.productPlanTabs);
                        }
                    }
                } else {
                    throw new Error(`There are no Plans available for your quotation. ${cxErrorMessageAppend}`);
                }
            } catch (error) {
                console.error("Request failed:", error.response?.data || error);
                let errorMessages = [`${techSupportErrorMessageAppend}`];
                this.$store.commit("global/dialog/populateContents", {
                    items: errorMessages,
                });

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    error_id: `15315693-3924-475c-8dde-dddf3f440cfc`,
                    event: `technical_error`,
                    timestamp: new Date().toISOString(),
                    request_status: error.response?.status || `unknown`,
                    request_path: error.config?.url || `unknown`,
                    error_message: error.message || `unknown`,
                });

                window.InsiderQueue = window.InsiderQueue || [];
                window.InsiderQueue.length = 0;
                window.InsiderQueue.push({
                    type: "custom_event",
                    value: [
                        {
                            event_name: "technical_error",
                            event_parameters: {
                                custom: {
                                    error_id: `15315693-3924-475c-8dde-dddf3f440cfc`,
                                    timestamp: new Date().toISOString(),
                                    request_status: error.response?.status || `unknown`,
                                    request_path: error.config?.url || `unknown`,
                                    error_message: error.message || `unknown`,
                                },
                            },
                        },
                    ],
                });
                window.InsiderQueue.push({ type: "init" });

                this.scrollToTop();
            } finally {
                setTimeout(() => {
                    this.toggleLoaderStatus({ status: false });
                    this.isReady = true;
                }, 600);
                document.addEventListener("scroll", this.draggable);
            }
        },
        async toggleBtnSelectPlan(planId) {
            const raw = this.productPlans?.Items ?? [];
            const plans = Array.isArray(raw) ? raw : Object.values(raw);
            const planItem = plans.find((plan) => String(plan.id) === String(planId));
            if (!planItem) {
                console.warn(`Plan with id ${planId} not found.`);
                return;
            }
            const productSlug = this.productPlans.Productslug;
            const categorySlug = this.productPlans.Productcategoryslug;
            const formRequestRaw = {
                ...this.productPlanSelected,
                Productcategoryslug: categorySlug,
                Productslug: productSlug,
                Item: planItem,
            };
            const formRequest = {
                ...formRequestRaw,
                Item: {
                    ...formRequestRaw.Item,
                    short_description: null,
                },
            };
            const formUrl = `web/product-application/quotation/select/${categorySlug}/${productSlug}`;
            const formRequestEncrypted = {
                dt: this.encryptionData(withAgentReferral(formRequest, this.getSecureLSData("__redirection_code_details__"))),
            };
            try {
                this.toggleLoaderStatus({ type: "translucent", status: true });
                const response = await this.$axios.$post(formUrl, formRequestEncrypted);
                if (response?.data?.attributes) {
                    const decrypted = this.decryptionData(response?.data?.attributes.encrypted);
                    if (decrypted.validated_request && decrypted.quotation_id && decrypted.quotation_number) {
                        this.productPlanSelected = formRequestRaw;
                        this.quotationReference = {
                            id: decrypted.quotation_id,
                            number: decrypted.quotation_number,
                        };
                        this.saveSecureLSData("__quotation_reference__", this.quotationReference);
                        this.saveSecureLSData("__product_plan_selected__", this.productPlanSelected);
                        const routeFullPath = this.$route?.fullPath;
                        const routeRedirectionPath = `/products/${categorySlug}/${productSlug}/application`;
                        if (routeFullPath === routeRedirectionPath) {
                            window.location.assign(routeFullPath);
                        } else {
                            window.location.assign(`${routeFullPath}/application`);
                        }
                    } else {
                        throw new Error(`There are no Plans available for your quotation. ${cxErrorMessageAppend}`);
                    }
                }
            } catch (error) {
                console.error("Request failed:", error.response?.data || error);
                let errorMessages = [`${techSupportErrorMessageAppend}`];
                this.$store.commit("global/dialog/populateContents", {
                    items: errorMessages,
                });

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    error_id: `9e7806cc-1658-4b52-a21f-f9ee2010862a`,
                    event: `technical_error`,
                    timestamp: new Date().toISOString(),
                    request_status: error.response?.status || `unknown`,
                    request_path: error.config?.url || `unknown`,
                    error_message: error.message || `unknown`,
                });

                window.InsiderQueue = window.InsiderQueue || [];
                window.InsiderQueue.length = 0;
                window.InsiderQueue.push({
                    type: "custom_event",
                    value: [
                        {
                            event_name: "technical_error",
                            event_parameters: {
                                custom: {
                                    error_id: `9e7806cc-1658-4b52-a21f-f9ee2010862a`,
                                    timestamp: new Date().toISOString(),
                                    request_status: error.response?.status || `unknown`,
                                    request_path: error.config?.url || `unknown`,
                                    error_message: error.message || `unknown`,
                                },
                            },
                        },
                    ],
                });
                window.InsiderQueue.push({ type: "init" });

                this.scrollToTop();
            } finally {
                setTimeout(() => {
                    this.toggleLoaderStatus({ status: false });
                }, 600);
            }
        },
        async toggleBtnSelectPlanFilter(tabType, slug) {
            this.productPlanSelected = {};
            this.productPlanTabs.Items[tabType].forEach((data) => {
                data.active = data.slug == slug;
            });
            await this.initialize();
        },
        getProductPlanTabSlug(tabType) {
            const activeCategory = this.productPlanTabs.Items[tabType].find((cat) => cat.active);
            return activeCategory ? activeCategory.slug.toUpperCase() : null;
        },
        toggleModalShowPlanDetails(id, title, description) {
            if (!this.modals) return;
            const modal = this.modals.find((m) => m.id === id);
            if (!modal) return;
            modal.title = title;
            modal.description = description;
            modal.show = true;
        },
        draggable() {
            const element = document.querySelector(`#${this.attr.medprotect_packages} .${this.attr.list}`);

            if (!element) return;

            element.style.cursor = "grab";
            let pos = { top: 0, left: 0, x: 0, y: 0 };
            const mouseDownHandler = (e) => {
                element.style.cursor = "grabbing";
                element.style.userSelect = "none";
                pos = {
                    left: element.scrollLeft,
                    top: element.scrollTop,
                    x: e.clientX,
                    y: e.clientY,
                };
                document.addEventListener("mousemove", mouseMoveHandler);
                document.addEventListener("mouseup", mouseUpHandler);
            };
            const mouseMoveHandler = (e) => {
                const dx = e.clientX - pos.x;
                const dy = e.clientY - pos.y;
                element.scrollTop = pos.top - dy;
                element.scrollLeft = pos.left - dx;
            };
            const mouseUpHandler = () => {
                element.style.cursor = "grab";
                element.style.removeProperty("user-select");
                document.removeEventListener("mousemove", mouseMoveHandler);
                document.removeEventListener("mouseup", mouseUpHandler);
            };
            element.addEventListener("mousedown", mouseDownHandler);
        },
    },
    async mounted() {
        await this.initialize();
    },
    destroyed() {
        document.removeEventListener("scroll", this.draggable);
    },
};
